export default __webpack_public_path__ + "static/media/docuhub.d9c1c11f.jpg";